import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-658e561f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ng-reason-body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center image-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/imgs/sorry.svg",
    alt: "sorry"
  })
], -1))
const _hoisted_3 = ["textContent"]


export default /*#__PURE__*/_defineComponent({
  __name: 'NgReasonBody',
  props: {
  text: {
    type: String,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createTextVNode(),
    _createElementVNode("p", {
      class: "ml-5 mr-5 mt-0 mb-5 text",
      textContent: _toDisplayString(__props.text)
    }, null, 8, _hoisted_3)
  ]))
}
}

})